import React from 'react';
import { fontWeightBold } from '../../../../ui-components/design-tokens';
import { TYPES } from '../../../../ui-components/typography/PlayText/PlayText';
import {
    StyledEditorialMessageLink,
    StyledEditorialMessageText,
    StyledEditorialMessage,
} from './EditorialMessage.styles';

const Message = ({ message, linkText, link, boldText = false, urgent = false }) =>
    message || link ? (
        <StyledEditorialMessage urgent={urgent}>
            {message && (
                <StyledEditorialMessageText type={TYPES.LARGE} weight={boldText ? fontWeightBold : undefined}>
                    {message}
                </StyledEditorialMessageText>
            )}
            {link && linkText && (
                <StyledEditorialMessageLink href={link} type={TYPES.LARGE}>
                    <span>{linkText}</span>
                </StyledEditorialMessageLink>
            )}
        </StyledEditorialMessage>
    ) : null;

export default Message;
